import { createContext, useContext } from 'react';

export type Ics202DraftApi = {
  openDraft: (sources?: string[], item?: string) => void;
  disabled: boolean;
  /** Boxes PRATUS AI is writing now, for any collaborator. Locked while set. */
  generatingSources: ReadonlySet<string>;
  /** Boxes the open composer will write. Empty once the draft is sent or closed. */
  pendingSources: ReadonlySet<string>;
  /** Boxes the last run could not draft, with the reason. */
  failedSources: ReadonlyMap<string, string>;
};

const Ics202DraftContext = createContext<Ics202DraftApi | null>(null);

export const Ics202DraftProvider = Ics202DraftContext.Provider;

export const useIcs202Draft = (): Ics202DraftApi | null =>
  useContext(Ics202DraftContext);
